// extracted by mini-css-extract-plugin
export default {"Link":"SearchChildrenLink_Link__6xO1u"};